/**
 * ROOFTOPS_XL — realism pass for the 160 m skyline.
 * All logic is shared by the rooftop family: see `rooftopsLayout.ts` (pure
 * layout + contract) and `rooftopsBuild.ts` (merged meshes). Contract bench:
 * `agent/bench-extras-rooftops.mjs`.
 */
export const mapIds = ["rooftops_xl"];
export { buildRooftopExtras as build } from "./rooftopsBuild.js";
